import { MLSListing } from '@aloft/toolkit-shared';

import MLSDataColumn from './MLSDataColumn';
import MLSDataInfoSection from './MLSDataInfoSection';
import MlsDataValueWithLabel from './MLSDataValueWithLabel';

const MLSSchoolInfo = ({ listingData }: { listingData: MLSListing }) => (
  <MLSDataInfoSection title="Schools" spanColumns={true}>
    <MLSDataColumn>
      <MlsDataValueWithLabel value={listingData.SchoolDistrict} label="School Disctrict" />
      <MlsDataValueWithLabel value={listingData.ElementarySchool} label="Elementary" />
      <MlsDataValueWithLabel value={listingData.HighSchool} label="High School" />
      <MlsDataValueWithLabel value={listingData.MiddleOrJuniorSchool} label="Junior High School" />
    </MLSDataColumn>
  </MLSDataInfoSection>
);

export default MLSSchoolInfo;
